module.exports = __webpack_public_path__ + "media/images/top/more-c03331f95e149d52111797592d032724.gif";